
import "./variables.css";
import React from "react";
import ReactDOM from "react-dom";
import "./assets/styles/fonts.css";
import "./assets/styles/index.css";
import App from "./containers/app/app";
import { getStore, loadStore } from "./redux/store";
import * as serviceWorker from "./serviceWorker";

const rootElement = document.getElementById("root");

loadStore().then(() => {
    ReactDOM.render(<App store={getStore()} />, rootElement);
});

if (module.hot) {
    module.hot.accept("./containers/app/app", _ => {
        ReactDOM.render(<App store={getStore()} />, rootElement);
    });
}

serviceWorker.register();
